export default __webpack_public_path__ + "static/media/main_sign.6d327322.png";